export const isVisibleOnWhite = (color: string): boolean => {
  // Convert any CSS color to RGB
  const toRGB = (c: string): [number, number, number] | null => {
    const ctx = document.createElement('canvas').getContext('2d');
    if (!ctx) return null;
    ctx.fillStyle = c;
    const rgb = ctx.fillStyle.match(/^rgba?\((\d+), (\d+), (\d+)/);
    return rgb ? [parseInt(rgb[1]), parseInt(rgb[2]), parseInt(rgb[3])] : null;
  };

  // Calculate relative luminance
  const luminance = (r: number, g: number, b: number): number => {
    const a = [r, g, b].map((v) => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  };

  const rgb = toRGB(color);
  if (!rgb) return false;
  const bgLum = luminance(...rgb);
  const whiteLum = 1;
  const contrast = (whiteLum + 0.05) / (bgLum + 0.05);
  return contrast >= 4.5;
};
